<template>
    <!-- User Profile Communication Edit Info Tab Content View From Account Profile -->
    <div>
        <div class="tabs-content-secondblock">
            <div class="row" v-if="ajaxCallinprogress">
                <div class="col-lg-12 py-5 px-3 mt-10">
                    <div class="flex-container">
                        <half-circle-spinner :animation-duration="1000" :size="60" color="#005dae" />
                    </div>
                </div>
            </div>
            <div class="row" v-if="!ajaxCallinprogress">
                <div class="col-lg-12">
                    <div class="ml-2 mr-1">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="infoHeader mt-4 pb-4">
                                    <div class="a-q-Jc-j-editcontactView mt-1">
                                        <div class="a-q-Jc-Pj-Ya-editcontactView">
                                            <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">
                                                Primary Email
                                                <sup class="fs-14 ml-1 mandatory">*</sup>
                                            </div>
                                            <div class="a-q-Jc-Lb-editcontactView">
                                                <span class="a-q-Jc-wg-editcontactView font-color">
                                                    <input class="inputField"
                                                        v-model="editCommunicationData.primary_email.value"
                                                        :maxlength="maxlengthaccountprimaryemail"
                                                        data-vv-scope="profile_data"
                                                        :disabled="loggedInUser.registration_type == 'email'"
                                                        data-vv-as="Primary Email" type="text" name="primary_email"
                                                        style="padding: 15px 50px 5px 0px !important;" />
                                                    <span class="input-group-addon"
                                                        style="cursor: pointer;position: absolute;top: 28px;text-align: right;right: 20px;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;"
                                                        v-if="!editCommunicationData.email.length" @click="addEmails()">
                                                        <i class="icon-plus-circle"
                                                            style="color: #005dae;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="a-q-Jc-j-editcontactView mt-1"
                                        v-for="(mail, index) in editCommunicationData.email" :key="'mail'+index">
                                        <div class="a-q-Jc-Pj-Ya-editcontactView">
                                            <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">Alternate Email
                                                - {{index+1}}</div>
                                            <div class="a-q-Jc-Lb-editcontactView">
                                                <span class="a-q-Jc-wg-editcontactView font-color">
                                                    <input class="inputField" v-validate="'email'" v-model="mail.value"
                                                        :maxlength="maxlengthaccountotheremails"
                                                        data-vv-scope="profile_data" data-vv-as="Alternate Email"
                                                        type="text" :name="'alternate_email'+index.toString()"
                                                        style="padding: 15px 110px 5px 0px !important;" />
                                                    <span class="text-grey float-right pr-12 fs-12"
                                                        style="margin-top: -24px;">{{maxlengthaccountotheremails - mail.value.length}}/{{maxlengthaccountotheremails}}</span>
                                                    <span class="input-group-addon removeBlocks"
                                                        style="cursor: pointer;position: absolute;margin-top: -26px;text-align: right;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;right: 36px;"
                                                        v-if="index+1==editCommunicationData.email.length"
                                                        @click="editCommunicationData.email.splice(index,1)">
                                                        <i class="icon-minus-circle"
                                                            style="color: #e82828;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                    </span>
                                                    <span class="input-group-addon removeBlocks"
                                                        style="cursor: pointer;position: absolute;margin-top: -26px;text-align: right;right: 18px;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;"
                                                        v-if="index+1!=editCommunicationData.email.length"
                                                        @click="editCommunicationData.email.splice(index,1)">
                                                        <i class="icon-minus-circle"
                                                            style="color: #e82828;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                    </span>
                                                    <span class="input-group-addon"
                                                        style="cursor: pointer;position: absolute;margin-top: -26px;text-align: right;right: 20px;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;"
                                                        v-if="index+1==editCommunicationData.email.length"
                                                        @click="addEmails()">
                                                        <i class="icon-plus-circle"
                                                            style="color: #005dae;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                    </span>
                                                    <span class="invalid-feedback-form text-danger"
                                                        v-show="errors.has('profile_data.alternate_email'+index.toString())">{{errors.first('profile_data.alternate_email'+index.toString())}}</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="a-q-Jc-j-editcontactView">
                                        <div class="a-q-Jc-Pj-Ya-editcontactView">
                                            <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">
                                                Primary Contact Number
                                                <sup class="fs-14 ml-1 mandatory">*</sup>
                                            </div>
                                            <div class="a-q-Jc-Lb-editcontactView ml-0">
                                                <div class="leftType">
                                                    <multiselect v-validate="'required'" class="digi-multiselect"
                                                        name="cType"
                                                        v-model="editCommunicationData.primary_phone.value.phone_type"
                                                        :options="phonetypes" :searchable="true" :close-on-select="true"
                                                        :show-labels="false" placeholder="Type" open-direction="bottom"
                                                        @select="$forceUpdate()"
                                                        :disabled="loggedInUser.registration_type == 'phone'"
                                                        style="margin-top: 1px; min-width: 130px !important;">
                                                        <template slot="singleLabel" slot-scope="props" class="d-flex">
                                                            <img v-if="props.option === 'Home'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/home-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Work'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/work-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Fax'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/fax-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Whatsapp'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/whatsapp-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Line'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/line-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Telegram'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/telegram-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Others'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/others-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Messenger'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/messenger-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Mobile'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/mobile-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            {{ props.option }}
                                                        </template>
                                                        <template slot="option" slot-scope="props" class="d-flex">
                                                            <img v-if="props.option === 'Home'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/home-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Work'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/work-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Fax'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/fax-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Whatsapp'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/whatsapp-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Line'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/line-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Telegram'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/telegram-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Others'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/others-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Messenger'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/messenger-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Mobile'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/mobile-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            {{ props.option }}
                                                        </template>
                                                        <template slot="noOptions">
                                                            <div class="text-secondary text-center fw-600">List is Empty
                                                            </div>
                                                        </template>
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-center fw-600">No Results
                                                                Found</div>
                                                        </template>
                                                    </multiselect>
                                                </div>
                                                <span class="a-q-Jc-wg-editcontactView text-runcate ml-4">
                                                    <vue-tel-input class="teleContactTransparentSeparate mt-2"
                                                        name="primary_phone_number"
                                                        v-model="editCommunicationData.primary_phone.value.phone_number"
                                                        ref="telInput" placeholder="Enter Phone Number"
                                                        :disabledFormatting="false" :valid-characters-only="true"
                                                        v-on:country-changed="countryChangedPrimary"
                                                        data-vv-scope="profile_data" data-vv-as="Phone Number"
                                                        v-validate="{required:true,min:13}" :maxLen="maxPhoneLength"
                                                        :disabled="loggedInUser.registration_type == 'phone'"
                                                        autocomplete="off"></vue-tel-input>
                                                    <span class="input-group-addon"
                                                        style="cursor: pointer;position: absolute;text-align: right;right: 20px;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;line-height: 28px;margin-top: -28px;"
                                                        v-if="!editCommunicationData.phone_details.length"
                                                        @click="addPhones()">
                                                        <i class="icon-plus-circle"
                                                            style="color: #005dae;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                    </span>
                                                    <span v-if="!editCommunicationData.primary_phone.verified"
                                                        class="input-group-addon"
                                                        style="cursor: pointer;position: absolute;text-align: right;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;line-height: 28px;margin-top: -30px;"
                                                        :style="!editCommunicationData.phone_details.length ? 'right: 38px' : 'right: 20px'"
                                                        @click="sendOtp">
                                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/verify-phone.svg"
                                                            width="14px">
                                                    </span>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important; position: absolute;"
                                                        v-show="errors.has('profile_data.primary_phone_number')">{{errors.first('profile_data.primary_phone_number')}}</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="a-q-Jc-j-editcontactView"
                                        v-for="(phone, index) in editCommunicationData.phone_details" :key="index">
                                        <div class="a-q-Jc-Pj-Ya-editcontactView">
                                            <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">
                                                Alternate Contact Number {{index+1}}
                                                <sup class="fs-14 ml-1 mandatory">
                                                    <el-tooltip class="item" effect="light"
                                                        content="The options for this field are configurable in the Settings page"
                                                        placement="right">
                                                        <i class="icon-information text-secondary"
                                                            style="font-size: 14px"></i>
                                                    </el-tooltip>
                                                </sup>
                                            </div>
                                            <div class="a-q-Jc-Lb-editcontactView ml-0">
                                                <div class="leftType" style="flex-direction: column;">
                                                    <multiselect class="digi-multiselect" :name="'pType'+index"
                                                        v-model="phone.value.phone_type" :options="phonetypes"
                                                        :searchable="true" :close-on-select="true" :show-labels="false"
                                                        v-validate="'required'" placeholder="Type"
                                                        open-direction="bottom"
                                                        style="margin-top: 1px; min-width: 130px !important;">
                                                        <template slot="singleLabel" slot-scope="props" class="d-flex">
                                                            <img v-if="props.option === 'Home'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/home-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Work'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/work-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Fax'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/fax-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Whatsapp'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/whatsapp-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Line'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/line-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Telegram'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/telegram-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Others'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/others-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Messenger'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/messenger-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Mobile'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/mobile-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            {{ props.option }}
                                                        </template>
                                                        <template slot="option" slot-scope="props" class="d-flex">
                                                            <img v-if="props.option === 'Home'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/home-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Work'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/work-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Fax'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/fax-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Whatsapp'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/whatsapp-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Line'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/line-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Telegram'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/telegram-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Others'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/others-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Messenger'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/messenger-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            <img v-if="props.option === 'Mobile'"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/mobile-contact-icon.svg"
                                                                style="margin-right: 5px;" />
                                                            {{ props.option }}
                                                        </template>
                                                        <template slot="noOptions">
                                                            <div class="text-secondary text-center fw-600">List is Empty
                                                            </div>
                                                        </template>
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-center fw-600">No Results
                                                                Found</div>
                                                        </template>
                                                    </multiselect>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;white-space:nowrap"
                                                        v-show="errors.has('pType'+index)">Phone type is required</span>
                                                </div>
                                                <span class="a-q-Jc-wg-editcontactView text-runcate ml-4">
                                                    <vue-tel-input class="teleContactTransparentSeparate mt-2"
                                                        :name="'phone_number'+index.toString()"
                                                        v-model="phone.value.phone_number"
                                                        v-on:country-changed="countryChangedAlternate($event, index)"
                                                        ref="telInput" placeholder="Enter Phone Number"
                                                        :disabledFormatting="false" :valid-characters-only="true"
                                                        v-validate="{min:13}" :maxLen="maxPhoneLength"
                                                        data-vv-scope="profile_data" data-vv-as="Phone Number"
                                                        autocomplete="off"></vue-tel-input>
                                                    <span class="input-group-addon removeBlocksPhone"
                                                        style="cursor: pointer;position: absolute;right: 18px;text-align: right;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;line-height: 28px;margin-top: -28px;"
                                                        v-if="index+1!=editCommunicationData.phone_details.length"
                                                        @click="editCommunicationData.phone_details.splice(index,1)">
                                                        <i class="icon-minus-circle"
                                                            style="color: #e82828;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                    </span>
                                                    <span class="input-group-addon removeBlocksPhone"
                                                        style="cursor: pointer;position: absolute;right: 36px;text-align: right;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;line-height: 28px;margin-top: -28px;"
                                                        v-if="index+1==editCommunicationData.phone_details.length"
                                                        @click="editCommunicationData.phone_details.splice(index,1)">
                                                        <i class="icon-minus-circle"
                                                            style="color: #e82828;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                    </span>
                                                    <span class="input-group-addon"
                                                        style="cursor: pointer;position: absolute;text-align: right;right: 20px;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;line-height: 28px;margin-top: -28px;"
                                                        v-if="index+1==editCommunicationData.phone_details.length"
                                                        @click="addPhones()">
                                                        <i class="icon-plus-circle"
                                                            style="color: #005dae;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                    </span>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important; position: absolute;"
                                                        v-show="errors.has('profile_data.phone_number'+index.toString())">Please
                                                        Enter a Valid Phone Number</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="infoHeader mt-4 pb-4">
                                    <div class="a-q-Jc-j-editcontactView">
                                        <div class="a-q-Jc-Pj-Ya-editcontactView">
                                            <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">Emergency
                                                Contact</div>
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-editcontactView">
                                        <div class="a-q-Jc-Pj-Ya-editcontactView pl-4">
                                            <table class="table table-noborder"
                                                v-if="editCommunicationData.emergency.length > 0">
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <label class="custom-control custom-checkbox digi-checkbox"
                                                                style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                                                <input :value="index" type="checkbox"
                                                                    @click="selectDeselectAllEmergencyContact"
                                                                    v-model="selectAll" class="custom-control-input" />
                                                                <span class="custom-control-indicator"
                                                                    style="font-size: 20px;top: -10px !important; color: #fff !important;"></span>
                                                                <span class="form-check-description fw-600"></span>
                                                            </label>
                                                        </th>
                                                        <th>Contact Name</th>
                                                        <th>Contact Number</th>
                                                        <th>
                                                            Relationship
                                                            <sup class="fs-14 mandatory">
                                                                <el-tooltip class="item" effect="light"
                                                                    content="The options for this field are configurable in the Settings page"
                                                                    placement="right">
                                                                    <i class="icon-information text-white"
                                                                        style="font-size: 14px"></i>
                                                                </el-tooltip>
                                                            </sup>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(emergencyContact,index) in editCommunicationData.emergency"
                                                        :key="index">
                                                        <td>
                                                            <label class="custom-control custom-checkbox digi-checkbox"
                                                                style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                                                <input v-model="deleteIds" :value="index"
                                                                    type="checkbox" class="custom-control-input" />
                                                                <span class="custom-control-indicator"
                                                                    style="font-size: 20px;top: -10px !important;"></span>
                                                                <span class="form-check-description fw-600"></span>
                                                            </label>
                                                        </td>
                                                        <td style="padding: 1rem 3rem !important">
                                                            <input class="inputField" type="text"
                                                                name="emergency_contact_name"
                                                                v-model="emergencyContact.emergency_contact_name"
                                                                :maxlength="maxlengthaccountemergencyname"
                                                                placeholder="Enter Emergency Contact Name"
                                                                data-vv-scope="profile_data"
                                                                data-vv-as="Emergency Contact Name" />
                                                        </td>
                                                        <td style="padding: 1rem 3rem !important">
                                                            <vue-tel-input class="teleContactTransparentSeparate mt-2"
                                                                :name="'emergency_contact_number'+index.toString()"
                                                                v-model="emergencyContact.emergency_contact_number.phone_number"
                                                                v-on:country-changed="countryChangedEmergency($event, index)"
                                                                ref="telInput" placeholder="Enter Phone Number"
                                                                :disabledFormatting="false"
                                                                :valid-characters-only="true" :maxLen="maxPhoneLength"
                                                                v-validate="{min:15}" data-vv-scope="profile_data"
                                                                data-vv-as="Emergency Phone Number" autocomplete="off">
                                                            </vue-tel-input>
                                                            <span class="invalid-feedback-form text-danger"
                                                                style="text-transform: none !important;"
                                                                v-show="errors.has('profile_data.emergency_contact_number'+index.toString())">Please
                                                                Enter a Valid Phone Number</span>
                                                        </td>
                                                        <td style="padding: 1rem 3rem !important">
                                                            <multiselect class="digi-multiselect mt-3"
                                                                v-model="emergencyContact.emergency_contact_relationship"
                                                                :options="emergency_contact_relationships"
                                                                :searchable="true" :close-on-select="true"
                                                                :show-labels="false" placeholder="Type"
                                                                open-direction="top" style="min-width: 150px;">
                                                                <template slot="noOptions">
                                                                    <div class="text-secondary text-center fw-600">List
                                                                        is Empty</div>
                                                                </template>
                                                                <template slot="noResult">
                                                                    <div class="text-secondary text-center fw-600">No
                                                                        Results Found</div>
                                                                </template>
                                                            </multiselect>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="d-flex justify-content-end mr-5 mt-3">
                                            <button v-if="editCommunicationData.emergency.length > 0"
                                                class="btn btn-new-danger btn-smm mr-3"
                                                @click="deleteEmergencyContact">- Delete Contact</button>
                                            <button class="btn btn-new-green btn-smm" @click="addEmergencyContact">+ Add
                                                Contact</button>
                                        </div>
                                    </div>
                                </div>

                                <div class="infoHeader mt-4 pb-4">
                                    <div class="a-q-Jc-j-editcontactView">
                                        <div class="a-q-Jc-Pj-Ya-editcontactView">
                                            <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">
                                                Social Media
                                                <sup class="fs-14 ml-1 mandatory">
                                                    <el-tooltip class="item" effect="light"
                                                        content="The options for this field are configurable in the Settings page"
                                                        placement="right">
                                                        <i class="icon-information text-secondary"
                                                            style="font-size: 14px"></i>
                                                    </el-tooltip>
                                                </sup>
                                            </div>
                                            <div class="a-q-Jc-Lb-editcontactView d-flex flex-column ml-0">
                                                <div class="a-q-Jc-j-editcontactView"
                                                    v-for="(media, index) in editCommunicationData.social_media"
                                                    :key="index">
                                                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                                                        <div class="a-q-Jc-Lb-editcontactView ml-0">
                                                            <div class="leftType">
                                                                <multiselect class="digi-multiselect"
                                                                    :name="'social_ype'+index"
                                                                    v-model="media.value.account_type"
                                                                    :options="['Facebook', 'Twitter']"
                                                                    :searchable="true" :close-on-select="true"
                                                                    :show-labels="false" v-validate="'required'"
                                                                    placeholder="Type" open-direction="bottom"
                                                                    style="margin-top: 1px; min-width: 130px !important;">
                                                                    <template slot="singleLabel" slot-scope="props"
                                                                        class="d-flex">
                                                                        <img v-if="props.option === 'Facebook'"
                                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/facebook.svg"
                                                                            style="margin-right: 5px; width: 15px" />
                                                                        <img v-if="props.option === 'Twitter'"
                                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/twitterr.svg"
                                                                            style="margin-right: 5px;" />
                                                                        {{ props.option }}
                                                                    </template>
                                                                    <template slot="option" slot-scope="props"
                                                                        class="d-flex">
                                                                        <img v-if="props.option === 'Facebook'"
                                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/facebook.svg"
                                                                            style="margin-right: 5px; width: 15px" />
                                                                        <img v-if="props.option === 'Twitter'"
                                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/twitterr.svg"
                                                                            style="margin-right: 5px;" />
                                                                        {{ props.option }}
                                                                    </template>
                                                                    <template slot="noOptions">
                                                                        <div class="text-secondary text-center fw-600">
                                                                            List is Empty</div>
                                                                    </template>
                                                                    <template slot="noResult">
                                                                        <div class="text-secondary text-center fw-600">
                                                                            No Results Found</div>
                                                                    </template>
                                                                </multiselect>
                                                                <span>|</span>
                                                            </div>
                                                            <div class="d-flex ml-4" style="width: 100%;margin-top:4px">
                                                                <input type="text"
                                                                    v-validate="{url: {require_protocol: true }}"
                                                                    class="form-control" data-vv-scope="profile_data"
                                                                    data-vv-as="Social Media"
                                                                    :name="'media_url'+index.toString()"
                                                                    :maxlength="maxlengthcompanysocialmedia"
                                                                    v-model="media.value.account_url"
                                                                    placeholder="Enter URL here"
                                                                    style="height: 32.7px !important; padding-right: 36px !important" />
                                                                <span class="input-group-addon removeBlocksSocial pr-1"
                                                                    :class="{removedAddSocial: index+1!=editCommunicationData.social_media.length}"
                                                                    style="cursor: pointer;position: absolute;margin-top: 7px;text-align: right;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;right: 38px !important;"
                                                                    @click="editCommunicationData.social_media.splice(index,1)"
                                                                    v-if="index != 0">
                                                                    <i class="icon-minus-circle"
                                                                        style="color: #e82828;font-size: 16px;width: 18px;height: 18px;line-height: 18px;z-index: 99;"></i>
                                                                </span>
                                                                <span class="input-group-addon"
                                                                    style="cursor: pointer;position: absolute;margin-top: 7px;text-align: right;right: 20px;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;"
                                                                    @click="addSocialMedia"
                                                                    v-if="index+1==editCommunicationData.social_media.length">
                                                                    <i class="icon-plus-circle"
                                                                        style="color: #005dae;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;margin-top: -5px !important;margin-left: 20em;"
                                                        v-show="errors.has('profile_data.media_url'+index.toString())">Please
                                                        Enter a Valid URL</span>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;margin-left: 7.5em;margin-top:-2px"
                                                        v-show="errors.has('social_ype'+index)">Social type is
                                                        required</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <verify-phone v-if="showVerifyModal" modal_name="verify_phone" @verfiy="verifyOtp"
            :phone="editCommunicationData.primary_phone.value.phone_number" @close="showVerifyModal = false">
        </verify-phone>
    </div>
</template>
<script>
    import {
        User
    } from "./mixins/user";
    import VueTextareaAutosize from "vue-textarea-autosize";
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import {
        EventBus
    } from "./eventBus/nav-bar-event.js";
    import VerifyPhone from "./alertModals/VerifyPhone";
    export default {
        data() {
            return {
                maxlengthaccountemergencyname: 20,
                maxlengthaccountemergencynotes: 1000,
                maxlengthaccountprimaryemail: 230,
                maxlengthaccountotheremails: 230,
                maxlengthcompanysocialmedia: 150,
                maxPhoneLength: 15,
                minHeight: 10,
                maxHeight: 350,
                editCommunicationData: {},
                ajaxCallinprogress: false,
                requestResponse: false,
                userBasicInfo: {
                    primary_email: "",
                    primary_phone: {
                        value: {
                            phone_type: "",
                            phone_number: "",
                            country_code: "",
                            dial_code: "",
                        },
                        privacy: "contacts",
                        verified: false,
                    },
                    social_media: [{
                        account_type: "Facebook",
                        account_url: "",
                    }, ],
                    emergency: [{
                        emergency_contact_name: "",
                        emergency_notes: "",
                        emergency_contact_relationship: "",
                        emergency_contact_number: {
                            phone_type: "",
                            phone_number: "",
                            country_code: "",
                            dial_code: "",
                            //isvalid: "",
                        },
                    }],
                    email: [],
                    phone_details: [],
                    socialMedia: {
                        Facebook: null,
                        Skype: null,
                        Twitter: null,
                    },
                },
                country: null,
                phonetypes: [
                    "Work",
                    "Home",
                    "Mobile",
                    "Fax",
                    "Others",
                    "Whatsapp",
                    "Line",
                    "Telegram",
                    "Messenger",
                ],
                emergency_contact_relationships: [
                    "Father",
                    "Mother",
                    "Sister",
                    "Brother",
                    "Son",
                    "Daughter",
                    "Spouse",
                    "Father-in-law",
                    "Mother-in-law",
                ],
                deleteIds: [],
                selectAll: false,
                showVerifyModal: false,
            };
        },
        mixins: [User],
        methods: {
            // Dial Code and Country Code
            countryChangedPrimary(country) {
                this.editCommunicationData.primary_phone.dial_code = country.dialCode;
                this.editCommunicationData.primary_phone.country_code = country.iso2;
            },
            countryChangedAlternate(country, index) {
                this.editCommunicationData.phone_details[index].dial_code = country.dialCode;
                this.editCommunicationData.phone_details[index].country_code = country.iso2;
            },
            countryChangedEmergency(country, index) {
                this.editCommunicationData.emergency[index].emergency_contact_number.dial_code = country.dialCode;
                this.editCommunicationData.emergency[index].emergency_contact_number.country_code = country.iso2;
            },
            // EditCommunication Empty Data Declration and Update User
            updateContactCommunication() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        if (!this.editCommunicationData.primary_email.value) {
                            delete this.editCommunicationData["primary_email"];
                        }
                        this.editCommunicationData.emergency.forEach((x) => {
                            if (x.emergency_contact_relationship == null) {
                                x.emergency_contact_relationship = "";
                            }
                            if (!(x.emergency_contact_name) && !(x.emergency_contact_number
                                    .phone_number) && !(x.emergency_contact_relationship)) {
                                this.editCommunicationData.emergency = this.editCommunicationData
                                    .emergency.filter(i => i != x);
                            }
                        });
                        this.editCommunicationData.social_media.forEach((x) => {
                            if (!(x.value.account_url)) {
                                this.editCommunicationData.social_media = this.editCommunicationData
                                    .social_media.filter(i => i != x);
                            }
                        });
                        if (this.editCommunicationData.primary_phone.value.phone_type == null) {
                            this.editCommunicationData.primary_phone.value.phone_type = "";
                        }
                        // if (this.editCommunicationData.primary_phone.phone_number) {
                        //   delete this.editCommunicationData.primary_phone["phone_number"]
                        // }
                        // if (this.editCommunicationData.primary_phone.phone_type) {
                        //   delete this.editCommunicationData.primary_phone["phone_type"]
                        // }
                        this.editCommunicationData.phone_details.forEach((x) => {
                            if (!(x.value.phone_number)) {
                                this.editCommunicationData.phone_details = this.editCommunicationData
                                    .phone_details.filter(i => i != x);
                            }
                            if (x.value.phone_type == null) {
                                x.value.phone_type = "";
                            }
                        });
                        this.editCommunicationData.email.forEach((x) => {
                            if (!(x.value)) {
                                this.editCommunicationData.email = this.editCommunicationData.email
                                    .filter(i => i != x);
                            }
                        });
                        this.saveEditUser(this.editCommunicationData);
                        this.$emit("updateUserData");
                    }
                });
            },
            // Getting User Data to Edit
            GetUserDetails(id) {
                this.ajaxCallinprogress = true;
                this.$http
                    .post("/users/get_user_data", {
                        user_id: id
                    })
                    .then(response => {
                        if (response.data.status_id == 1) {
                            this.userBasicInfo = response.data.response;
                            this.editCommunicationData = JSON.parse(
                                JSON.stringify(this.userBasicInfo)
                            );
                            if (!("primary_email" in this.editCommunicationData)) {
                                Object.assign(this.editCommunicationData, {
                                    primary_email: {
                                        value: "",
                                        privacy: "contacts",
                                    },
                                });
                            };
                            if (!("emergency" in this.editCommunicationData) || this.editCommunicationData.emergency
                                .length === 0) {
                                Object.assign(this.editCommunicationData, {
                                    emergency: [{
                                        emergency_contact_name: "",
                                        emergency_notes: "",
                                        emergency_contact_relationship: "",
                                        emergency_contact_number: {
                                            phone_type: "",
                                            phone_number: "",
                                            country_code: "",
                                            dial_code: "",
                                        },
                                    }, ]
                                });
                            }
                            if (this.editCommunicationData.social_media.length == 0) {
                                this.editCommunicationData.social_media = [{
                                    value: {
                                        account_type: "Facebook",
                                        account_url: "",
                                    },
                                    privacy: "contacts",
                                }]
                            }
                            if (!("primary_phone" in this.editCommunicationData)) {
                                Object.assign(this.editCommunicationData, {
                                    primary_phone: {
                                        value: {
                                            phone_type: "",
                                            phone_number: "",
                                            country_code: "",
                                            dial_code: "",
                                        },
                                        privacy: "contacts",
                                        verified: false,
                                    },
                                });
                            }
                            if ("primary_phone" in this.editCommunicationData && !("value" in this
                                    .editCommunicationData.primary_phone)) {
                                Object.assign(this.editCommunicationData.primary_phone, {
                                    value: {
                                        phone_type: "",
                                        phone_number: "",
                                        country_code: "",
                                        dial_code: "",
                                    },
                                });
                            }
                            this.ajaxCallinprogress = false;
                        }
                    })
                    .catch(error => {});
            },
            addEmergencyContact() {
                this.editCommunicationData.emergency.push({
                    emergency_contact_name: "",
                    emergency_notes: "",
                    emergency_contact_relationship: "",
                    emergency_contact_number: {
                        phone_type: "",
                        phone_number: "",
                        country_code: "",
                        dial_code: "",
                    },
                }, );
            },
            deleteEmergencyContact() {
                if (this.deleteIds.length === this.editCommunicationData.emergency.length) {
                    this.editCommunicationData.emergency = [];
                    this.deleteIds = [];
                } else {
                    this.deleteIds.forEach(x => {
                        this.editCommunicationData.emergency.splice(x, 1);
                        this.deleteIds = this.deleteIds.filter(e => e != x);
                    });
                }
            },
            selectDeselectAllEmergencyContact() {
                if (this.deleteIds.length === this.editCommunicationData.emergency.length) {
                    this.deleteIds = [];
                } else {
                    for (let i = 0; i < this.editCommunicationData.emergency.length; i++) {
                        if (!this.deleteIds.includes(i)) {
                            this.deleteIds.push(i);
                        }
                    }
                }
            },
            addSocialMedia() {
                this.editCommunicationData.social_media.push({
                    value: {
                        account_type: "",
                        account_url: "",
                    },
                    privacy: "contacts",
                });
            },
            async sendOtp() {
                let phone = this.editCommunicationData.primary_phone.value.phone_number.replace(/\s/g, "");
                let res = await this.$http.post("/users/phone/send/otp", {
                    phone_number: phone
                });
                if (res.data.status_id == 1) {
                    this.showVerifyModal = true;
                    this.$modal.show("verify_phone");
                }
            },
            async verifyOtp(otp) {
                let params = {
                    otp: otp,
                    phone_number: this.editCommunicationData.primary_phone.value.phone_number.replace(/\s/g,
                        ""),
                };
                let res = await this.$http.post("/users/phone/verify/otp", params);
                if (res.data.status_id == 1) {
                    if (this.$route.params.id) {
                        this.GetUserDetails(this.$route.params.id);
                    } else {
                        this.GetUserDetails(this.loggedInUser._id);
                    }
                }
            }
        },
        components: {
            VueTextareaAutosize,
            HalfCircleSpinner,
            VerifyPhone,
        },
        watch: {
            deleteIds: function () {
                if (this.deleteIds.length === this.editCommunicationData.emergency.length) {
                    this.selectAll = true;
                } else {
                    this.selectAll = false;
                }
            },
            "editCommunicationData.emergency": function () {
                if (!this.editCommunicationData.emergency.length) {
                    this.selectAll = false;
                }
            }
        },
        mounted() {
            EventBus.$on("communicationInformation", () => {
                this.updateContactCommunication();
            });
            EventBus.$on("hideuser", () => {
                this.hideEdit();
            });
        },
        created() {
            if (this.$route.params.id) {
                this.GetUserDetails(this.$route.params.id);
            } else {
                this.GetUserDetails(this.loggedInUser._id);
            }
            const dict = {
                custom: {
                    primary_phone_number: {
                        required: () => "Phone Number is Required",
                        min: () => "Please Enter a Valid Phone Number",
                    },
                },
            };
            this.$validator.localize("en", dict);
        },
        destroyed() {
            EventBus.$off("communicationInformation");
            EventBus.$off("hideuser");
        },
        computed: {
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/EditContactCommunicationView.vue